import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL } from "../../shared/constant";
import Select from "react-select";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";
const Users = () => {
  const [partyData, setPartyData] = useState([]);
  const [roles, setRoles] = useState([]);
  const [roleType, setRoleType] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [partyDataOriginal, setPartyDataOriginal] = useState([]);
  const [loading, setLoading] = useState(true);



  const getParty = (roleId) => {
    axios.post(API_URL.USERS_LIST, { type: roleId }).then(
      (res) => {
        if (res.data.status === 1) {
          setPartyData(res.data.data.data);
           setPartyDataOriginal(res.data.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,

        });
      }
    );
  };

  const getRoles = () => {
    axios.post(API_URL.USERS_ROLES, {}).then(
      (res) => {
        if (res.data.status === 1) {
          let rls = [{
            label: 'All',
            value: 0
          }]
          res.data.data.forEach((r) => {
            rls.push({
              label: r.name,
              value: r.id
            });
          })
          setRoles(rls);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,

        });
      }
    );
  };

  const deleteUser = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.USERS_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = partyData.filter((r) => r.id !== row.id);
              setPartyData(newData);
            }
            toast.success(row.name + " Delete Successfully", { autoClose: 3000 });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  const approveUser = (row, status) => {
    Swal.fire({
      title: (status === 0) ? 'Are you sure to block this user?' : 'Are you sure to approve this?',
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.USERS_APPROVE, { user_id: row.id, status: status }).then(
          (res) => {
            if (res.data.status === 1) {
              let newIndex = partyData.findIndex((r) => r.id === row.id);
              partyData[newIndex].status = status;
              setPartyData(partyData);
            }
            toast.success(row.name + " approved Successfully", { autoClose: 3000 });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

const handleSearchChange = async (e) => {
  const value = e.target.value;
  setSearchValue(value);

  if (value.length >= 3) {
    try {
      const res = await axios.post(API_URL.USERS_SEARCH, { text: value });

      if (Array.isArray(res.data)) {
        setPartyData(res.data);
      } else if (Array.isArray(res.data.data)) {
        setPartyData(res.data.data);
      }
    } catch (error) {
      toast.error("Search failed", { autoClose: 2000 });
    }
  } else {
    setPartyData(partyDataOriginal);
  }
};

  useEffect(() => {
    getParty();
    getRoles();
  }, []);
  return (
    <>
      <div className="row">
        <div className="col-4">
          <h1>Users <small className="me-2">({partyData.length})</small></h1>
        </div>
        <div className="col-8">
          <div className="d-flex align-items-center  justify-content-end">
            <div className="form-group mb-0 mr-2" style={{ width: 300 }}>
              <Select
                options={roles}
                value={roles.find((r) => r.value == roleType)}
                // styles={styles}
                onChange={(e) => {
                  setRoleType(e.value);
                  getParty(e.value);
                }
                }
              />
            </div>
            <div className="col-md-5 mb-0 mr-2">
              <div className="form-group mb-0 mr-2">
                <input
                  type="text"
                  value={searchValue}
                  onChange={handleSearchChange}
                  className="form-control"
                  placeholder="Search by Name ..."
                />

              </div>
            </div>
            <Link to={"/users/add"} className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add User
            </Link>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div>
                  <div className="table-responsive">
                    <table className="table">
                      <thead className="">
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Contact</th>
                          <th>Location</th>
                          <th
                            className="text-center"
                            style={{ width: "200px" }}
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {partyData.map((row, key) => {
                          return (
                            <tr key={key}>
                              <td>{key + 1}</td>
                              <td>{row.name}</td>
                              <td>{row.email}</td>
                              <td>{row.contact_no}</td>
                              <td>{row.city_name}, {row.state_name}</td>
                              <td className="d-flex justify-content-center gap-2" style={{ width: "200px" }}>
                                <Link to={"/users/edit/" + row.id} className="btn btn-sm btn-secondary mr-2">
                                  <i className="fa fa-edit me-1"></i> Edit
                                </Link>
                                {row.status === 0 ? <button onClick={() => approveUser(row, 1)} className="btn btn-sm btn-success mr-2">
                                  <i className="fa fa-check me-1"></i> Approve
                                </button> :
                                  <button onClick={() => approveUser(row, 0)} className="btn btn-sm btn-danger mr-2">
                                    <i className="fa fa-trash me-1"></i> Block
                                  </button>}
                                <button onClick={() => deleteUser(row)} className="btn btn-sm btn-danger">
                                  <i className="fa fa-trash me-1"></i> Delete
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Users;
